var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8246 20.122C22.2822 15.1231 17.061 6.84996 14.5178 2.40216C14.2174 1.87632 13.6637 1.5 13 1.5C12.3363 1.5 11.7826 1.87632 11.4814 2.40216C8.93904 6.84996 3.71862 15.1231 1.17628 20.122C1.06538 20.3395 1 20.5823 1 20.841C1 21.7566 1.76883 22.5 2.71559 22.5L13 22.4992L23.2852 22.5C24.232 22.5 25 21.7566 25 20.841C25 20.5823 24.9354 20.3395 24.8246 20.122Z",
    stroke: "#E72626",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0005 16V8",
    stroke: "#E72626",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.3804C14 18.9324 13.552 19.3804 13 19.3804C12.448 19.3804 12 18.9324 12 18.3804C12 17.8284 12.448 17.3804 13 17.3804C13.552 17.3804 14 17.8284 14 18.3804Z",
    fill: "#E72626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.669e8a031f85dc35b8c61a2df0e46f3d.svg";
export { ForwardRef as ReactComponent };